import { useContext, useState } from "react";
import { AppContext } from "../App";
import logo from "../assets/logo.png";
import {
  MdClose,
  MdHome,
  MdInfoOutline,
  MdOutlineContactPhone,
  MdBusinessCenter,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp
} from "react-icons/md";
import Backdrop from "./Backdrop";

export default function SideBar() {
  const appContext = useContext(AppContext);
  
  // Track mobile submenu expansions locally for a cleaner UI
  const [aboutExpanded, setAboutExpanded] = useState(false);
  const [servicesExpanded, setServicesExpanded] = useState(false);

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item, subItem = null) {
    appContext.navTo({
      item,
      subItem,
    });
    closeSideBar();
  }

  function isActive(item, subItem = null) {
    if (item === "home") {
      return !appContext.navItem || appContext.navItem === "home";
    }
    if (subItem) {
      return appContext.navItem === item && appContext.navSubItem === subItem;
    }
    return appContext.navItem === item;
  }

  return (
    <>
      {/* Dim overlay behind the clean compact navigation dropdown */}
      <Backdrop
        style={{
          visibility: appContext.isSideBarOpen ? "visible" : "hidden",
          opacity: appContext.isSideBarOpen ? "1" : "0",
          zIndex: "9998",
          pointerEvents: appContext.isSideBarOpen ? "auto" : "none",
          transition: "opacity 0.3s ease"
        }}
        onClick={closeSideBar}
      />

      {/* The Short Dropdown Panel replacing the old side drawer layout */}
      <aside className="MobileDropdownMenu" data-open={appContext.isSideBarOpen}>
        <div className="mobile-menu-inner">
          
          {/* TOP HEADER SECTION */}
          <div className="menu-header-bar">
            <div className="menu-brand-lockup" onClick={() => goTo("home")}>
              <img src={logo} alt="Blessing Management Consultancy" className="menu-logo-img" />
              <div className="menu-title-stack">
                <strong className="text-primary font-title-bold">Blessing</strong>
                <span className="text-muted font-regular font-10">CONSULTANCY</span>
              </div>
            </div>

            <button className="menu-close-trigger" onClick={closeSideBar}>
              <MdClose />
            </button>
          </div>

          {/* MAIN LINK COMPONENT MATRIX */}
          <div className="menu-links-scroller">
            
            {/* HOME */}
            <button className="menu-item-row" data-active={isActive("home")} onClick={() => goTo("home")}>
              <span className="menu-item-icon-wrap"><MdHome /></span>
              <span className="font-semi-bold">Home</span>
            </button>

            {/* ABOUT COLLAPSIBLE ACCORDION */}
            <div className="menu-accordion-wrapper">
              <button 
                className="menu-item-row" 
                data-active={isActive("about")} 
                onClick={() => setAboutExpanded(!aboutExpanded)}
              >
                <span className="menu-item-icon-wrap"><MdInfoOutline /></span>
                <span className="font-semi-bold flex-grow-1 text-start">About Us</span>
                {aboutExpanded ? <MdKeyboardArrowUp className="accordion-arrow" /> : <MdKeyboardArrowDown className="accordion-arrow" />}
              </button>
              
              <div className="menu-submenu-tray" data-expanded={aboutExpanded}>
                <button 
                  className="submenu-item-row font-regular" 
                  data-active={isActive("about", "overview")} 
                  onClick={() => goTo("about", "overview")}
                >
                  Corporate Overview
                </button>
                <button 
                  className="submenu-item-row font-regular" 
                  data-active={isActive("about", "team")} 
                  onClick={() => goTo("about", "team")}
                >
                  Our Professional Team
                </button>
              </div>
            </div>

            {/* SERVICES COLLAPSIBLE ACCORDION */}
            <div className="menu-accordion-wrapper">
              <button 
                className="menu-item-row" 
                data-active={isActive("services")} 
                onClick={() => setServicesExpanded(!servicesExpanded)}
              >
                <span className="menu-item-icon-wrap"><MdBusinessCenter /></span>
                <span className="font-semi-bold flex-grow-1 text-start">Practice Services</span>
                {servicesExpanded ? <MdKeyboardArrowUp className="accordion-arrow" /> : <MdKeyboardArrowDown className="accordion-arrow" />}
              </button>
              
              <div className="menu-submenu-tray" data-expanded={servicesExpanded}>
                <button 
                  className="submenu-item-row font-regular" 
                  data-active={isActive("services", "audit")} 
                  onClick={() => goTo("services", "audit")}
                >
                  Statutory Audit & Assurance
                </button>
                <button 
                  className="submenu-item-row font-regular" 
                  data-active={isActive("services", "tax")} 
                  onClick={() => goTo("services", "tax")}
                >
                  Taxation & Compliance Hub
                </button>
                <button 
                  className="submenu-item-row font-regular" 
                  data-active={isActive("services", "accounting")} 
                  onClick={() => goTo("services", "accounting")}
                >
                  Accounting & Advisory
                </button>
                <button 
                  className="submenu-item-row font-regular" 
                  data-active={isActive("services", "accounting")} 
                  onClick={() => goTo("services", "accounting")}
                >
                  Management & Advisory
                </button>
              </div>
            </div>

            {/* CONTACT */}
            <button className="menu-item-row" data-active={isActive("contact")} onClick={() => goTo("contact")}>
              <span className="menu-item-icon-wrap"><MdOutlineContactPhone /></span>
              <span className="font-semi-bold">Contact Registry</span>
            </button>

          </div>

          {/* QUICK DIRECT ADVISORY HOTLINE FOOTER */}
          <div className="menu-quick-action-tray border-top mt-2 pt-3">
            <a href="tel:+255222123456" className="menu-action-phone-btn btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2 py-2">
              <MdOutlineContactPhone />
              <span className="font-semi-bold font-14">Direct Desk Helpline</span>
            </a>
          </div>

        </div>
      </aside>
    </>
  );
}